module.exports = __webpack_public_path__ + "img/img4.cc0cecd6.jpg";